import { API } from 'aws-amplify';
import { USER_API_GATEWAY_ENDPOINT_NAME } from '../../aws-exports';

export function getBuilds() {
  return API.get(USER_API_GATEWAY_ENDPOINT_NAME, '/api/almabetter/builds', {});
}

export function startBuild() {
  return API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/almabetter/start-build',
    {}
  );
}
